export { default as ErrorComponent } from './Error';
